module.exports = __webpack_public_path__ + "static/media/makeup.82cda288.png";